import useSWR from "swr"

import {
  getMultiUnitGridABTestingVariant,
  MultiUnitGridABTestVariants,
} from "@/app/src/hooks/useMultiUnitGridABTesting"
import { getSearchPviAlgoABTestVariant } from "@/app/src/hooks/usePVIABTesting"
import { apiClientCommon } from "services/apiClientCommon"
import { useAppSelector } from "stores/hooks"
import { selectSearchQuery } from "stores/search/searchSlice"
import { getCookie } from "utils/cookies"

const searchPropertiesCountFetcher = async ({
  url,
  ...params
}: {
  url: string
  sortBy: {
    highToLow: boolean
    lowToHigh: boolean
    bestDeals: boolean
    biggestSavings: boolean
    recommended: boolean
    guestRatings: boolean
  }
} & Parameters<typeof apiClientCommon.getPropertiesCountGET>[0]["params"]) => {
  const countApiResponse = await apiClientCommon.getPropertiesCountGET({
    params,
  })

  return countApiResponse.data.data
}

const useSearchListingPropertiesCount = () => {
  const searchQuery = useAppSelector(selectSearchQuery)
  const isGoogle = getCookie("isGoogle") === "true"
  const searchPviAlgoVariant = getSearchPviAlgoABTestVariant()

  const params =
    searchQuery?.name?.toLowerCase() === "near by"
      ? { ...searchQuery, isMapDragged: true }
      : searchQuery
  const multiUnitCollapsedEnabled =
    getMultiUnitGridABTestingVariant() ===
    MultiUnitGridABTestVariants.MULTI_UNIT
  return useSWR(
    searchQuery
      ? ({
          url: `/api/search/count`,
          // isSearchAddress,
          multiUnitCollapsedEnabled,
          ...params,
          isgoogle: isGoogle || false,
          pviVersion: searchPviAlgoVariant,
        } as unknown as Parameters<
          typeof apiClientCommon.getPropertiesCountGET
        >[0]["params"] & {
          url: string
        })
      : null, // to resolve multiple api call issue
    searchPropertiesCountFetcher,
    {
      loadingTimeout: 15000,
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default useSearchListingPropertiesCount
